import '@/shared/styles/external-styles';

import * as React from 'react';

import { withProviders } from '@/app/providers';

import { NetworkToast } from '@/features/network-toast';

import { PageSeo } from '@/shared/lib/seo';
import { EnhancedAppProps } from '@/shared/types/enhanced-app-props';

function App(props: EnhancedAppProps) {
  const { Component, pageProps } = props;

  const Layout = Component.Layout ?? React.Fragment;

  return (
    <>
      <PageSeo
        description="Marital – это российская косметика для поддержания естественной красоты.
Команда технологов, химиков и косметологов разработала уходовые средства для российских женщин с учетом старения и строения кожи.
В нашей лаборатории мы проводим исследования с привлечением добровольцев и получаем колоссальные результаты, направленные на поддержание молодости и красоты вашей кожи.
Мы искренне надеемся, что вы сможете подобрать полную линейку уходовых средств и по достоинству их оценить."
      />

      <Layout>
        <Component {...pageProps} />

        <NetworkToast />
      </Layout>
    </>
  );
}

export default withProviders(App);
